module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/2fa-open-lock-7807d1af470fd928c327bc123c3479f1.png";